import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const InstrumentsRoutes: RouteBundle = {
  domain: 'instruments',
  routes: [
    {
      urlPattern: 'instrument-gateways',
      handler: EditorRoutes.instrumentGateways.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: 'connections/listing',
      handler: EditorRoutes.connectionListing.bind(EditorRoutes),
    },
    {
      urlPattern: 'connections/:connectionId',
      handler: EditorRoutes.connectionEditor.bind(EditorRoutes),
      legacy: true,
    },
  ],
};
